import { mediacoreApi } from '@apis/mediacoreApi'
import { getAllQuery } from '@apis/mediacoreQueries'
import { TermsAndConditions } from '@types'
const termsConditiosURL = 'core/terminos-condiciones'

const termsConditionsApi = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getTermsAndConditions: builder.query<TermsAndConditions[], void>({
      query: getAllQuery(termsConditiosURL),
      providesTags: ['TermsAndConditions'],
    }),
    acceptTermsAndConditions: builder.mutation<void, void>({
      query: () => ({
        url: `${termsConditiosURL}/aceptar/`,
        method: 'POST',
      }),
      invalidatesTags: ['TermsAndConditions'],
    }),
    getLastTermsAndConditions: builder.query<TermsAndConditions, void>({
      query: getAllQuery(`${termsConditiosURL}/ultimo`),
      providesTags: ['TermsAndConditions'],
    }),
  }),
  overrideExisting: false,
})
export const { useGetTermsAndConditionsQuery, useAcceptTermsAndConditionsMutation, useGetLastTermsAndConditionsQuery } = termsConditionsApi
